import { render, staticRenderFns } from "./IntegrationDetails.vue?vue&type=template&id=19a60836&scoped=true&"
import script from "./IntegrationDetails.vue?vue&type=script&lang=js&"
export * from "./IntegrationDetails.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationDetails.vue?vue&type=style&index=0&id=19a60836&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a60836",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationDetails.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationDetails.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QIcon,QCard,QSpace,QChip,QBtn,QCarousel,QCarouselSlide,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QCard,QSpace,QChip,QBtn,QCarousel,QCarouselSlide,QDialog})
